import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Modal from "react-awesome-modal";
import popupLogo from "../../../static/images/popup-logo.png";

import {
  getListOfAttachmentsForSubcategoryByUserId,
  downloadAttachment,
  downloadBulkSubCatAttachment,
  sendEmailForDoc,
  getListofGenericMaster,
  getListofGenericMasterQueryForView,
  ViewSubCatAttachment,
} from "../../../services/graphql/queries/category-management";
import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../../miscellaneous/react-toastify";

import DisplayErrors from "../../Common/DisplayErrors";

import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";

import downloadSvg from "../../../static/images/download.svg";
import Emailnotify from "../../../static/images/EmaildownBtn.svg";
import whiteDownloadSvg from "../../../static/images/whiteDownloadSvg.svg";
import gridSvg from "../../../static/images/grid.svg";
import SimpleReactValidator from "simple-react-validator";
import ReactModal from "../../Common/ReactModal";
import InputComponent from "../../Common/form-component/InputComponent";
import { GET_PERMISSION } from "../../../services/graphql/queries/accessPermission";
import { addPermission } from "../../../services/redux/actions/loginActions";
import { GrFormView  } from "react-icons/gr";
import { getListofMasterQuery } from "../../../services/graphql/queries/masters";

const FileSaver = require("file-saver");
const mime = require("mime-types");

class Attachments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      loading: false,
      errors: [],
      isSelectAll: false,
      downloadAttachmentArr: [],
      attachments: [],
      modalVisibleEmail: false,
      addAttachmentModalVisible: false,
      EmailCancelModalVisible: false,
      name: "",
      users: [],
      userIds: [],
      selectedRecord: null,
      attachmentDetail: {
        name: "",
      },
      selectedRecord: null,
      authDetail: {
        emailId: "",
      },
      emailProvider: {
        inputEmail: "",
      },
      emailAttachment: {},
      reactModalVisible: false,
      modalMessage: "Email sent Successfully",
      selectedOption: null,
      accessPermission: [],
      sending: false,
      cancel: false,
      isDownloading: false,
      loadingDownload: false,
      downloadingAttachments: {},
      master:[],
      allowedFormat:null,
    };

    this.validator = new SimpleReactValidator({
      validators: {
        multipleEmails: {
          message: "Please enter valid and unique email addresses",
          rule: (value) => {
            if (!value) return false; // Required field check
            const emailPattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
            // Split emails, trim spaces, and validate each one
            // Convert value to string in case it's not
            const strValue = String(value);
            const emails = strValue.split(",").map((email) => email.trim());

            // Check for unique emails
            const uniqueEmails = new Set(emails);
            if (uniqueEmails.size !== emails.length) {
              return false; // if Duplicates found
            }

            return emails.every((email) => emailPattern.test(email));
          },
          required: true, //This ensures that the field must be filled in
        },
      },
      element: (message) => (
        <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
          {message}
        </div>
      ),
    });
  }
  handleInputForEmailNotification = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    this.setState((prevState) => {
      return {
        authDetail: {
          ...prevState.authDetail,
          [name]: value,
        },
      };
    });
  };
  handleChange = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({
      emailProvider: {
        ...prevState.emailProvider,
        inputEmail: value, // Update email input
      },
    }));
    this.validator.showMessages("inputEmail"); // Force validation message update
  };

  sendEmail(emailAttachment) {
    if (this.validator.allValid()) {
      const emailList = this.state.emailProvider.inputEmail
        .split(",")
        .map((email) => email.trim());

      // Remove duplicate emails
      const uniqueEmailList = [...new Set(emailList)];

      let emailProvider = {
        inputEmail: "",
      };

      this.validator.hideMessages();
      this.setState({
        loading: true,
        modalVisibleEmail: true,
        emailProvider,
        sending: true,
      });
      this.setState({ sending: true, modalVisibleEmail: true }, () => {
        this.props.client
          .query({
            query: sendEmailForDoc,
            variables: {
              attachmentId: emailAttachment.id,
              attachmentName: emailAttachment.name,
              emailUsers: uniqueEmailList,
            },

            fetchPolicy: "network-only",
          })
          .then((result) => {
            console.log("result", result);
            if (result?.data) {
              let responseMessage = JSON.parse(
                result?.data?.sendEmailforDocument
              );
              let msg = responseMessage?.message;
              console.log("parsed responseMessage", msg);
              if (msg.includes("Emails sent successfully")) {
                msg="Email/s sent successfully"
                this.setState({
                  reactModalVisible: true,
                  sending: false,
                  modalVisibleEmail: false,
                  modalMessage: <span style={{ color: "green" }}>{msg}</span>,
                });
              } else {
                this.setState({
                  reactModalVisible: true,
                  sending: false,
                  modalVisibleEmail: false,
                  modalMessage: <span style={{ color: "red" }}>{msg}</span>,
                });
              }
            }
          })
          .catch((error, result) => {
            console.log("~~~error:send email ", error);

            let message = errorMessage(error);

            // Extracting error message
            let errorMsgText = message[0];
            console.log("message", errorMsgText);

            this.setState({
              sending: false,
              loading: false,
              errors: [errorMsgText],
            });

            console.log("error", this.state.errors);

            this.timer = setTimeout(() => {
              this.setState({ errors: [] });
            }, SET_TIMEOUT_VALUE);
          });
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  // onClickOfAttachment(attachment) {
  //   if (attachment.attachmentType == 1) {
  //     this.setState((prevState) => ({
  //       downloadingAttachments: {
  //         ...prevState.downloadingAttachments,
  //         [attachment.id]: true, // Set only the clicked attachment as downloading
  //       },
  //       isDownloading:true
  //     }));
  //     // successMsg("Downloading File, please wait...");

  //     this.props.client
  //       .mutate({
  //         mutation: downloadAttachment,
  //         variables: {
  //           attachmentId: attachment.id,
  //         },
  //         fetchPolicy: "no-cache",
  //       })
  //       .then(async(result) => {

  //         let attachmentData = result.data.downloadSubCatAttachment;

  //         let presignedUrl = attachmentData?.fileData; // Get pre-signed URL
  //         console.log(presignedUrl);
          

  //         let fileName = attachmentData?.fileName;
  //         console.log("filename",attachmentData);
          
          

  //         if (!presignedUrl || !fileName) {
  //           console.error("Presigned URL or filename is missing!");
  //           this.setState({ isDownloading: false });
  //           return;
  //         }
    
  //         // Modify filename by removing the first 32 characters
  //         let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

  //         // let link = document.createElement("a");
  //         // link.href = presignedUrl;
  //         // // link.setAttribute("download", modifiedFileName); 
  //         // link.target="_blank";
  //         // document.body.appendChild(link);
  //         // link.click();
  //         // document.body.removeChild(link);

  //         const ext = fileName.split(".").pop().toLowerCase();

  //         const officeExts = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
  //         const inlineExts = ["pdf", "jpg", "jpeg", "png", "gif"];

  //         let openUrl=presignedUrl;
          

  //         if (officeExts.includes(ext)) {
  //           openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(presignedUrl)}`;
  //         }
  
  //         if (inlineExts.includes(ext) || officeExts.includes(ext)) {  
  //           // window.open(openUrl, "_blank");
  //           const newWindow = window.open("", "_blank");
  //         if (newWindow) {
  //           const html = `
  //             <html>
  //               <head>
  //                 <title>${attachmentData.fileName}</title>
  //               </head>
  //               <body style="margin:0">
  //                 <iframe src="${openUrl}" style="width:100%; height:100vh; border:none;"></iframe>
  //               </body>
  //             </html>
  //           `;
  //           newWindow.document.write(html);
  //           newWindow.document.close();
  //         }
             
  //         } else {
  //           // Force download (e.g., zip, rar)
  //           const link = document.createElement("a");
  //           link.href = presignedUrl;
  //           link.setAttribute("download", fileName);
  //           document.body.appendChild(link);
  //           link.click();
  //           document.body.removeChild(link);
  //         }

  //         successMsg("Download Initiated");
  //         this.setState({
  //           errors: [],
  //           loading: false,
  //           isDownloading:false
  //         });
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, // Reset only the clicked attachment/download File
  //           },
  //         }));
  //       })
  //       .catch((error) => {
  //         console.log("~~~error in download: ", error);
  //         let message = errorMessage(error);
  //         errorMsg(message[0]);
  //         this.setState({
  //           loading: false,
  //           errors: [errorMessage(error)],
  //         });
  //         setTimeout(() => {
  //           this.setState({ isDownloading: false });
  //         }, 3000);
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, 
  //           },
  //         }));
  //         this.timer = setTimeout(() => {
  //           this.setState({ errors: [] });
  //         }, SET_TIMEOUT_VALUE);
  //       });
  //   } else {
  //     let data = { GridId: attachment.gridId.id };
  //     localStorage.setItem("GridId-Input", JSON.stringify(data));
  //     // this.props.history.push("/grid-input-edit");
  //     window.open("/grid-input-edit");
  //   }
  // }

  onClickOfAttachment(attachment) {
    if (attachment.attachmentType == 1) {
      this.setState((prevState) => ({
        downloadingAttachments: {
          ...prevState.downloadingAttachments,
          [attachment.id]: true, // Set only the clicked attachment as downloading
        },
        isDownloading:true
      }));
      // successMsg("Downloading File, please wait...");

      this.props.client
        .mutate({
          mutation: downloadAttachment,
          variables: {
            attachmentId: attachment.id,
          },
          fetchPolicy: "no-cache",
        })
        .then(async(result) => {

          let attachmentData = result.data.downloadSubCatAttachment;

          let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

          let fileName = attachmentData?.fileName;

          if (!presignedUrl || !fileName) {
            console.error("Presigned URL or filename is missing!");
            this.setState({ isDownloading: false });
            return;
          }
    
          // Modify filename by removing the first 32 characters
          let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

          let link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", modifiedFileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          successMsg("Download Initiated");
          this.setState({
            errors: [],
            loading: false,
            isDownloading:false
          });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, // Reset only the clicked attachment/download File
            },
          }));
        })
        .catch((error) => {
          console.log("~~~error in download: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({
            loading: false,
            errors: [errorMessage(error)],
          });
          setTimeout(() => {
            this.setState({ isDownloading: false });
          }, 3000);
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, 
            },
          }));
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      let data = { GridId: attachment.gridId.id };
      localStorage.setItem("GridId-Input", JSON.stringify(data));
      // this.props.history.push("/grid-input-edit");
      window.open("/grid-input-edit");
    }
  }
  getMaster() {
    
      this.props.client
        .query({
          query: getListofMasterQuery,
          variables: {
            descriptionName: this.state.description,
            offset: this.state.offset,
            pageNo: this.state.currentPage,
          },
          fetchPolicy: "network-only",
        })
        .then((result) => {
          const master = result.data.getListofMaster;

          console.log("master",master);
          
          
          
          this.setState({
            master:[...master],
            // pageOfItems: master,
            loading: false,
            error: "",
          });
        })
        .catch((error) => {
          console.log("~~~error: ", error);
          this.setState({ loading: false, error: error.message });
        });
    }




  // onClickOfAttachment = async (attachment) => {
  //   if (attachment.attachmentType !== 1) return;
  
  //   this.setState({ isDownloading: true });
  
  //   try {
  //     const result = await this.props.client.mutate({
  //       mutation: downloadAttachment,
  //       variables: { attachmentId: attachment.id },
  //       fetchPolicy: "no-cache"
  //     });
  
  //     const { fileData, fileName, mimeType } = result.data.downloadSubCatAttachment;
  
  //     // Decode base64 data
  //     const binaryString = atob(fileData);
  //     const bytes = new Uint8Array(binaryString.length);
  //     for (let i = 0; i < binaryString.length; i++) {
  //       bytes[i] = binaryString.charCodeAt(i);
  //     }
  
  //     // Create blob with correct MIME type
  //     const blob = new Blob([bytes], { type: mimeType });
  //     const blobUrl = URL.createObjectURL(blob);
  
  //     // Strategy 1: Use window.open for certain file types
  //     if (['application/pdf', 'image/', 'text/'].some(type => mimeType.startsWith(type))) {
  //       window.open(blobUrl, '_blank');
  //     } 
  //     // Strategy 2: Use hidden iframe for other types
  //     else {
  //       const iframe = document.createElement('iframe');
  //       iframe.style.display = 'none';
  //       iframe.src = blobUrl;
  //       document.body.appendChild(iframe);
  //       setTimeout(() => document.body.removeChild(iframe), 10000);
  //     }
  
  //     // Strategy 3: Always provide download option
  //     const a = document.createElement('a');
  //     a.href = blobUrl;
  //     a.download = fileName;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  
  //     // Clean up
  //     setTimeout(() => {
  //       URL.revokeObjectURL(blobUrl);
  //       this.setState({ isDownloading: false });
  //     }, 1000);
  
  //     successMsg("File should open automatically if your browser allows it");
  
  //   } catch (error) {
  //     errorMsg("Failed to open file");
  //     console.error("File open error:", error);
  //     this.setState({ isDownloading: false });
  //   }
  // };







  
//   onClickOfMasterFile(attachment) {
//   console.log("attachment", attachment);

//   const masterObj = this.state.master.find(
//     (m) => m.description === "File Formats for view"
//   );

//   if (!masterObj) {
//     console.error("Master not found for File Formats for view!");
//     return;
//   }

//   const masterForId = masterObj.Id;

//   // 1Fetch allowed file formats dynamically
//   this.props.client
//     .query({
//       query: getListofGenericMasterQueryForView,
//       variables: { masterFor: masterForId },
//       fetchPolicy: "no-cache",
//     })
//     .then((result) => {
//       // const formats = result.data.getListofGenericMaster.map((item) =>
//       //   item.description.toLowerCase()
//       // );
//       const formats=result.data.getListofGenericMaster;

//       console.log("Supported formats:", formats);

//       // 2Get presigned URL for the clicked attachment
//       this.props.client
//         .mutate({
//           mutation: downloadAttachment,
//           variables: { attachmentId: attachment.id },
//           fetchPolicy: "no-cache",
//         })
//         .then((res) => {
//           const data = res.data.downloadSubCatAttachment;
//           const fileUrl = data?.fileData;
//           const fileName = data?.fileName;

//           if (!fileUrl || !fileName) {
//             console.error("Presigned URL or file name missing!");
//             return;
//           }

//           // Get file extension
//           const ext = fileName.split(".").pop().toLowerCase();
//           console.log("File extension:", ext);

//           if (!formats.includes(ext)) {
//             console.warn(`File format .${ext} not supported for view`);
//             return;
//           }

//           // Define which formats to open where
//           const officeExts = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
//           const inlineExts = ["pdf", "jpg", "jpeg", "png"];

//           let openUrl = fileUrl;

//           if (formats.includes(ext)) {
            
//             openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
//           } else if (["jpg", "jpeg", "png"].includes(ext)) {
//             // Images / PDFs → open directly or use Google Docs Viewer
//             // openUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
//             // openUrl=fileUrl;
//           }

//           // 5Open in new tab using an iframe
//           const newWindow = window.open("", "_blank");
//           if (newWindow) {
//             const html = `
//               <html>
//                 <head><title>${fileName}</title></head>
//                 <body style="margin:0">
//                   <iframe src="${openUrl}" style="width:100%; height:100vh; border:none;"></iframe>
//                 </body>
//               </html>
//             `;
//             newWindow.document.write(html);
//             newWindow.document.close();
//           } else {
//             console.warn("Unable to open new tab (popup blocked?)");
//           }
//         })
//         .catch((error) => {
//           console.error("Error getting presigned URL:", error.message);
//         });
//     })
//     .catch((error) => {
//       console.error("Error fetching formats:", error.message);
//     });
// }


fetchAllowedFormats = () => {
  const masterObj = this.state.master.find(
    (m) => m.description === "File Formats for view"
  );

  if (!masterObj) return;

  this.props.client
    .query({
      query: getListofGenericMasterQueryForView,
      variables: { masterFor: masterObj.Id },
      fetchPolicy: "no-cache",
    })
    .then((result) => {
      const formats = result.data.getListofGenericMaster.map((item) =>
        item.description.toLowerCase()
      );
      this.setState({ allowedFormat: formats });
    })
    .catch((error) => {
      console.error("Error fetching formats:", error.message);
    });
};

isViewSupported = (attachment) => {
  const { allowedFormat } = this.state;
  console.log("affff",attachment);
  
  // If formats are not loaded yet, temporarily enable icons
  if (!allowedFormat) return true;

  const ext = attachment.name?.split(".").pop().toLowerCase();
  console.log("isvewsupp",ext);
  
  return allowedFormat.includes(ext);
};


onClickOfMasterFile(attachment) {
  const masterObj = this.state.master.find(
    (m) => m.description === "File Formats for view"
  );

  if (!masterObj) {
    console.error("Master not found for File Formats for view!");
    return;
  }

  const masterForId = masterObj.Id;

  // Fetch allowed file formats dynamically
  this.props.client
    .query({
      query: getListofGenericMasterQueryForView,
      variables: { masterFor: masterForId },
      fetchPolicy: "no-cache",
    })
    .then((result) => {
      const formats = result.data.getListofGenericMaster.map((item) =>
        item.description.toLowerCase()
      );
      // this.setState({allowedFormat:formats})
      console.log("Supported formats:", formats);

      this.props.client
        .mutate({
          mutation: ViewSubCatAttachment,
          variables: { attachmentId: attachment.id },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          const data = res.data.viewSubCatAttachment;
          const fileUrl = data?.fileData;
          const fileName = data?.fileName;

          if (!fileUrl || !fileName) {
            console.error("Presigned URL or file name missing!");
            return;
          }

          const ext = fileName.split(".").pop().toLowerCase();
          console.log("exct", ext);
          
          if (!formats.includes(ext)) {
            errorMsg(`File format .${ext} not supported for view`);
            return;
          }

          // Office file extensions
          const officeExts = formats.filter((f) =>
            ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(f)
          );

          const imageExts = ["jpg", "jpeg", "png"];

          let openUrl = "";
          if (officeExts.includes(ext)) {
            openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
          } else if (imageExts.includes(ext)) {
            const imageHtml = `
              <html>
                <head>
                  <style>
                    body {
                      margin: 0;
                      background: #000;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 100vh;
                    }
                    img {
                      max-width: 100%;
                      max-height: 100%;
                      object-fit: contain;
                    }
                  </style>
                </head>
                <body>
                  <img src="${fileUrl}" alt="${fileName}" />
                </body>
              </html>
            `;
            const blob = new Blob([imageHtml], { type: "text/html" });
            openUrl = URL.createObjectURL(blob);
          } else {
            openUrl = fileUrl; // PDF or other viewable types
          }

          const newWindow = window.open("", "_blank");
          if (newWindow) {
            const faviconLink =
              document.querySelector("link[rel='icon']")?.href ||
              `${window.location.origin}/favicon.ico`;

            const html = `
              <html>
                <head>
                  <title>${fileName}</title>
                  <link rel="icon" type="image/png" href="${faviconLink}" />
                </head>
                <body style="margin:0">
                  <iframe src="${openUrl}" style="width:100%; height:100vh; border:none;"></iframe>
                </body>
              </html>
            `;
            const blob = new Blob([html], { type: "text/html" });
            const blobUrl = URL.createObjectURL(blob);
            newWindow.location.href = blobUrl;
          }
          else {
            console.warn("Unable to open new tab (popup blocked?)");
          }

        })
        .catch((error) => {
          console.error("Error getting presigned URL:", error.message);
        });
    })
    .catch((error) => {
      console.error("Error fetching formats:", error.message);
    });
}



downloadBulkSubCatAttachment() {
  if (this.state.loadingDownload) return;

  this.setState({ loadingDownload: true ,isDownloading:true});
  const { isSelectAll, downloadAttachmentArr, attachments } = this.state;
  let attachmentArr = [];
  if (isSelectAll) {
    attachmentArr = downloadAttachmentArr;
  } else {
    for (let i = 0; i < attachments.length; i++) {
      if (attachments[i].attachmentType == 1 && attachments[i].canDownload)
        attachmentArr.push(attachments[i].id);
    }
  }
  if (!attachmentArr.length) {
    this.setState({
      errors: ["Please select atleast one attachment to download."],
      loadingDownload: false,
      isDownloading:false
    });
    this.timer = setTimeout(() => {
      this.setState({ errors: [] });
    }, SET_TIMEOUT_VALUE);
    return;
  }
  this.setState({ loading: true });
  // successMsg("Downloading File, please wait...");
  this.props.client
    .mutate({
      mutation: downloadBulkSubCatAttachment,
      variables: {
        subCategoryId: this.state.category,
        attachmentArr: attachmentArr,
      },
      fetchPolicy: "no-cache",
    })
    .then((result) => {
      let attachmentData = result.data.downloadBulkSubCatAttachment;

      let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

      let fileName = attachmentData?.fileName;

      if (!presignedUrl || !fileName) {
        console.error("Presigned URL or filename is missing!");
        this.setState({ isDownloading: false ,loadingDownload:false});
        return;
      }

      let link = document.createElement("a");
      link.href = presignedUrl;
      link.setAttribute("download", fileName); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.getListOfAttachments();
      successMsg("Download Initiated");
      this.setState({
        errors: [],
        loading: false,
        isSelectAll: false,
        isDownloading:false,
        loadingDownload: false,
      });
    })
    .catch((error) => {
      console.log("~~~error: ", error);
      let message = errorMessage(error);
      errorMsg(message[0]);
      
      this.setState({ loading: false, errors: [errorMessage(error)],loadingDownload: false,isDownloading:false });
      this.timer = setTimeout(() => {
        this.setState({ errors: [] });
      }, SET_TIMEOUT_VALUE);
    });
}
onModalForEmail(attachment) {
  this.setState({
    modalVisibleEmail: !this.state.modalVisibleEmail,
    emailAttachment: attachment,
  });
}
submitModal = () => {
  this.setState({ reactModalVisible: false, modalMessage: "" });

  // this.props.onUpdateUser();
};
onEmailCancelModalVisible() {
  let emailProvider = {
    inputEmail: [],
  };
  this.validator.hideMessages();
  this.setState({
    modalVisibleEmail: !this.state.modalVisibleEmail,
    emailProvider: emailProvider,
    
  });
}

getListOfAttachments() {
  this.setState({ loading: true });
  this.props.client
    .query({
      query: getListOfAttachmentsForSubcategoryByUserId,
      variables: {
        subCategoryId: this.props.category,
      },
      fetchPolicy: "network-only",
    })
    .then((result) => {
      var attachments =
        result.data.getListOfAttachmentsForSubcategoryByUserId;
      let downloadAttachmentArr = [];
      for (let i = 0; i < attachments.length; i++) {
        attachments[i].canDownload = false;
        if (attachments[i].attachmentType == 1) {
          downloadAttachmentArr.push(attachments[i].id);
        }
      }

      this.initialState = {
        attachments: attachments,
        downloadAttachmentArr: downloadAttachmentArr,
      };
      this.setState({ ...this.initialState, loading: false, error: "" });
    })
    .catch((error) => {
      this.setState({
        loading: false,
        error: error.message,
        attachments: [],
        downloadAttachmentArr: [],
      });
    });
}

isSelectAll(e) {
  var attachments = this.state.attachments;

  for (let i = 0; i < attachments.length; i++) {
    if (e.target.checked) attachments[i].canDownload = true;
    else attachments[i].canDownload = false;
  }

  this.initialState = {
    attachments: attachments,
  };
  this.setState({ ...this.initialState, isSelectAll: e.target.checked });
}

isAttachmentDownloadable(e, attachmentData, index) {
  const { isSelectAll, attachments } = this.state;
  if (isSelectAll) return;
  attachments[index].canDownload = e.target.checked;
  this.setState({ attachments: attachments });
}
getPermission() {
  this.props.client
    .query({
      query: GET_PERMISSION,
      fetchPolicy: "network-only",
    })
    .then((result) => {
      console.log(
        "notify permission ",
        JSON.parse(result.data.getPermission)
      );
      this.setState(
        {
          accessPermission: JSON.parse(result.data.getPermission),
          //loading: true,
        },

        () => {
          console.log(
            "Updated accessPermission",
            this.state.accessPermission
          );

          this.props.dispatch(addPermission(this.state.accessPermission));
        }
      );
    })
    .catch((error) => {
      this.props.dispatch(addPermission({}));
      console.log("~~~error: ", error);
    });
}

componentDidMount() {
  this.getListOfAttachments();
  this.getPermission();
  setTimeout(() => {
  this.getMaster();
}, 0);
}

componentDidUpdate(prevProps, prevState) {
  if (
    prevState.master !== this.state.master &&
    this.state.master.length > 0
  ) {
    this.fetchAllowedFormats(); // master is now ready
  }

  if (prevProps.category !== this.props.category) {
    this.setState(
      { category: this.props.category, isSelectAll: false, attachments: [] },
      () => {
        this.getListOfAttachments();
      }
    );
  }

}


  render() {
    const {
      loading,
      errors,
      isSelectAll,
      attachments,
      downloadAttachmentArr,
      authDetail,
      emailAttachment,
      reactModalVisible,
      modalMessage,
      emailProvider,
      accessPermission,
    } = this.state;
    {{console.log("allow",this.state.allowedFormat);
    }}
    return (
      <>
      {/* {this.state.isDownloading && (
          <div
            style={{
              
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(255, 255, 255, 0.9)", 
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", 
              zIndex: 1000,
              width: "350px", 
              height: "70px", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
            }}
          >
            <div>
              <p style={{}}>
                <div className="uploading-container">
                  <span className="uploading-text" style={{fontSize:""}}>Downloading</span>
                  <span className="uploading-dot dot-1">.</span>
                  <span className="uploading-dot dot-2">.</span>
                  <span className="uploading-dot dot-3">.</span>
                  <span className="uploading-dot dot-4">.</span>
                  <span className="uploading-dot dot-5">.</span>
                
                </div>
              </p>
            </div>
          </div>
        )} */}
      <div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          modalMessage={modalMessage}
          submitModal={this.submitModal}
        />
        <div className="row">
          <div className="col-md-12">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h1 className="heading m-b-0">Document List</h1>
              </div>
              {attachments.length ? (
                <div className="col-md-6 text-right">
                  {/* <label>Select All: </label>
                            <input type="checkbox" style={{marginLeft: '5px'}} 
                            onClick={(e)=>this.isSelectAll(e)} 
                            checked={isSelectAll}
                            /> */}
                  {downloadAttachmentArr.length ? (
                    <button
                      className="btn btn-danger m-l-45"
                      onClick={() => this.downloadBulkSubCatAttachment()}
                      disabled={this.state.loadingDownload}
                    >
                      <img src={whiteDownloadSvg} alt="" width="16"/> All
                    </button>
                  ) : null}
                </div>
              ) : null}
            </div>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-12">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <span className="danger-link">
                      <DisplayErrors errors={errors} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="table-responsive"
              // style={{overflowX: 'hidden'}}
            >
              <table className="table table-style-1 ">
                <thead>
                  <tr>
                    <th scope="col" width={250}>
                      FILE NAME
                    </th>
                    <th scope="col" width={420}>
                      DESCRIPTION
                    </th>
                    <th className="" scope="col" width={250}>
                      <div className="text-center bg-primar" style={{width:"33%"}}>
                        <span className="m-r-70 bg-inf">ACTION</span>{" "}
                      </div>
                      
                      {attachments.length ? (
                        <>
                          {downloadAttachmentArr.length ? (
                            <input
                              type="checkbox"
                              className="form-control"
                              style={{ height: "18px", marginTop: "-20px" }}
                              onClick={(e) => this.isSelectAll(e)}
                              checked={isSelectAll}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {attachments.filter(
                    (attachment) => attachment.description !== "Tender"
                  ).length // Exclude attachments with description as "Tender"
                    ? attachments
                        .filter(
                          (attachment) => attachment.description !== "Tender"
                        ) // Apply filter again for mapping
                        .map((attachment, index) => {
                          return (
                            <tr  key={index}>
                              <td
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title={attachment.name}
                              >
                                {attachment.name.length > 40
                                  ? attachment.name.substring(0, 40) + "..."
                                  : attachment.name}
                              </td>
                              <td>{attachment.description}</td>
                              <td>
                                {attachment.attachmentType == 2 ? (
                                  <a
                                    className="link-click m-l-10"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Go To Grid"
                                    onClick={() =>
                                      this.onClickOfAttachment(attachment)
                                    }
                                  >
                                    <img src={gridSvg} alt="" />
                                  </a>
                                ) : (
                                  <>
                                  {/* <a className="link-click"
                                      href="#"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="View"
                                      onClick={(e) => {
                                                      e.preventDefault(); // prevent page jump
                                                      this.onClickOfMasterFile(attachment);
                                                    }}
                                      
                                      >
                                      
                                     <GrFormView color="#69951a" fontSize="26px"/>
                                  </a> */}
                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="View"
                                    onClick={(e) => {
                                      // If formats not loaded yet OR file not supported, disable click
                                      if (!this.state.allowedFormat || !this.isViewSupported(attachment)) {
                                        e.preventDefault();
                                        return;
                                      }

                                      e.preventDefault();
                                      this.onClickOfMasterFile(attachment);
                                    }}
                                    style={{
                                      pointerEvents: (!this.state.allowedFormat || this.isViewSupported(attachment)) ? "auto" : "none",
                                      opacity: (!this.state.allowedFormat || this.isViewSupported(attachment)) ? 1 : 0.5,
                                      cursor: (!this.state.allowedFormat || this.isViewSupported(attachment)) ? "pointer" : "not-allowed",
                                      textDecoration: "none",
                                    }}
                                  >
                                    <GrFormView
                                      color={(!this.state.allowedFormat || this.isViewSupported(attachment)) ? "#69951a" : "#ccc"}
                                      fontSize="26px"
                                    />
                                  </a>


                                    <a
                                      className="link-click m-l-10"
                                      href="#"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Download"
                                      onClick={() => {
                                        if (!this.state.downloadingAttachments[attachment.id]) {
                                          this.onClickOfAttachment(attachment);
                                        }
                                      }}
                                    >
                                      <img
                                        src={downloadSvg}
                                        alt=""
                                        width="16"
                                        style={{
                                          opacity: this.state.downloadingAttachments[attachment.id]
                                            ? 0.5
                                            : 1,
                                        }} // only clicked Download button is disabled
                                      />
                                    </a>
                                    {accessPermission &&
                                    accessPermission[245] ? (
                                      <a
                                        className="link-click m-l-10"
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Email Notification"
                                        onClick={() =>
                                          this.onModalForEmail(attachment)
                                        }
                                      >
                                        <img
                                          src={Emailnotify}
                                          alt=""
                                          width="16"
                                        />
                                      </a>
                                    ) : null}

                                    <input
                                      type="checkbox"
                                      className="form-control"
                                      style={{
                                        height: "18px",
                                        marginTop: "-20px",
                                      }}
                                      onClick={(e) =>
                                        this.isAttachmentDownloadable(
                                          e,
                                          attachment,
                                          index
                                        )
                                      }
                                      checked={attachment.canDownload}
                                    />
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })
                    : null}
                </tbody>
              </table>
              {!attachments.length && !loading ? (
                <div style={{ textAlign: "center" }}>No Data</div>
              ) : null}
            </div>
          </div>
        </div>

        <Modal
          visible={this.state.modalVisibleEmail}
          effect="fadeInDown"
          width="800"
        >
          <div style={{ padding: "20px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-body"
                style={{ paddingTop: 0, display: "" }}
              >
                <div className="col-10" style={{ display: "flex" }}>
                  <figure>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-45 m-b-35"  title={this.state.emailAttachment?.name} style={{wordBreak: "break-word"}}>
                    Send document <span style={{fontStyle:"italic"}}>{this.state.emailAttachment?.name?.length > 40
      ? this.state.emailAttachment.name.substring(0, 40) + "..."
      : this.state.emailAttachment?.name}</span> to below email/s:
                  </h1>
                </div>

                <div className="col-10" style={{ width: "82%" }}>
                  <div className="form-group">
                    <div
                      className="row"
                      style={{
                        display:
                          this.state.errors.length === 0 ? "none" : "block",
                      }}
                    >
                      <div className="col">
                        <div className="alert" role="alert">
                          <DisplayErrors errors={this.state.errors} />
                        </div>
                      </div>
                    </div>
                    <div className="ui-widget">
                      <InputComponent
                        required
                        type="text"
                        title="emailId"
                        name="inputEmail"
                        label="Enter valid e-mail"
                        value={emailProvider.inputEmail}
                        placeholder="abc@gmail.com , xyz@gmail.com"
                        handleChange={this.handleChange}
                        validator={this.validator}
                        //validation="required|email"
                        validation="required|multipleEmails"
                      />
                      {this.state.sending && (
                        <p
                          style={{
                            color: "black",
                            fontSize: "17px",
                            marginTop: "",
                            fontWeight:"600"
                            
                          }}
                        >
                          {/* Sending<span className="dot-flashing"></span> */}
                          <div className="uploading-container">
                            <span className="uploading-text">Sending</span>
                            <span className="uploading-dot dot-1">.</span>
                            <span className="uploading-dot dot-2">.</span>
                            <span className="uploading-dot dot-3">.</span>
                          </div>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onEmailCancelModalVisible()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger popup-button-danger"
                    onClick={() => this.sendEmail(emailAttachment)}
                    disabled={this.state.sending}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
      </>
    );
  }
}
export default withRouter(connect()(withApollo(Attachments)));
